module.exports = __webpack_public_path__ + "media/images/icons/map/ingoing-icon-0957b2f26783046f7ef9818b5340173f.svg";